import { wa, pageEventTypes, pageTypes } from 'apps/analytics';

export function reportSubscribe(frequency, sku) {
  wa.triggerPageEvent(pageEventTypes.SUBSCRIPTIONS_ADD_PRODUCT, {
    FREQUENCY: frequency,
    SKU: sku,
  });
}

export function reportFrequencyChange(frequency, sku) {
  wa.triggerPageEvent(pageEventTypes.SUBSCRIPTIONS_FREQUENCY, {
    FREQUENCY: frequency,
    SKU: sku,
  });
}

export function reportQuantityChange(quantity, sku) {
  wa.triggerPageEvent(pageEventTypes.SUBSCRIPTIONS_QUANTITY, {
    QUANTITY_UPDATE: quantity,
    SKU: sku,
  });
}

export function determinePageType(landingPage, productsPageRoute) {
  if (landingPage && landingPage.docModel === 'SUBSCRIPTIONS_BRAND_SHOP') {
    return pageTypes.SUBSCRIPTIONS_BRANDSHOP;
  }
  if (productsPageRoute.location.pathname === productsPageRoute.basePath) {
    return pageTypes.SUBSCRIPTIONS;
  }
  return pageTypes.SUBSCRIPTIONS_PRODUCTS;
}

export function determinePageStatistic(landingPage) {
  return Boolean(landingPage && landingPage.docModel === 'SUBSCRIPTIONS_FEATURED_CATEGORY_BANNER');
}

export function reportResetConfirmed() {
  wa.triggerPageEventWithDescription(pageEventTypes.SUBSCRIPTIONS_RESET, {
    CONFIRM_REMOVING_ALL_SUBSCRIPTIONS: true,
  });
}

export function reportResetCanceled() {
  wa.triggerPageEventWithDescription(pageEventTypes.SUBSCRIPTIONS_RESET, {
    CONFIRM_REMOVING_ALL_SUBSCRIPTIONS: false,
  });
}
